/**
 * RISK-DELETE.MODAL
 * Ask for deleting risk
 * If older risk this will be archived
 */

import Modal from "@/components/modal"
import EnterCodeWidget from "@/widgets/enter-code.widget"
import { useSelector } from "react-redux"
import riskStore from "@/features/risks/entities/risk/model/risk.store"
import { useAppDispatch } from "@/core/root-reducer"
import ModalConfirm from "@/components/modal-confirm"
import { formatDate } from "@/utils/format-date.utils"
import Checkbox from "@/components/checkbox"
import { t } from "i18next"
import { useState } from "react"
import LoadingModal from "@/modals/loading.modal"

interface Props {
  isBatch?: boolean
  onClose: Function
}

export default function RiskDeleteModal({ onClose }: Props) {
  const dispatch = useAppDispatch()

  //Selectors
  const status = useSelector(riskStore.selectors.status)
  const active = useSelector(riskStore.selectors.active)

  //State
  const [destroyAssociated, setDestroyAssociated] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  //Click on next
  const next = async () => {
    setIsLoading(true)
    const response: any = await dispatch(riskStore.thunks.removeEntity(active.id))

    if (destroyAssociated && !response.error) {
      for (let i = 0; i < active.associatedRisks.length; i++) {
        const risk = active.associatedRisks[i]
        await dispatch(riskStore.thunks.removeEntity(risk.id))
      }
    }

    onClose()
  }

  //Ask confirmation (risk will be archived)
  if (active.dateValidated) {
    return (
      <Modal onClose={() => onClose()} title="Supprimer le risque">
        {isLoading && <LoadingModal />}
        <p>
          <b>
            {`Le risque « ${active.name} » sera archivé à la date d'aujourd'hui (${formatDate(null, false, false)}).`}
          </b>
        </p>
        <p className="grey-t">
          {t("unit")} : <b>{active.unitName}</b>
        </p>
        {active.associatedRisks.length > 0 && (
          <div className="flex mb-40 items-center">
            <div className="mr-20">
              <Checkbox active={destroyAssociated} onClick={() => setDestroyAssociated(!destroyAssociated)} />
            </div>
            <div className="flex-1 text-sm grey-t">
              <b>{"Je souhaite également supprimer ce risque pour les unités de travail suivantes"}</b>
              {` : ${active.associatedRisks.map((x) => x.unitName).join(", ")}`}
            </div>
          </div>
        )}
        <EnterCodeWidget onCancel={() => onClose()} onNext={next} status={status} />
      </Modal>
    )
  } else {
    return (
      <ModalConfirm
        onNo={() => onClose()}
        onYes={next}
        text={`« ${active.name} »`}
        textBold="Souhaitez-vous supprimer la mise en jour ?"
      />
    )
  }
}
